import { jsxs as d, jsx as i } from "react/jsx-runtime";
import { E as g, S as v } from "./icons.types-0722eef5.js";
function p({ title: c, titleId: s, size: l, width: n, height: a, extended: r = !1, ...h }) {
  const o = r ? g : v, t = l ? o[l] : n || o[r ? "s" : "l"], e = l ? o[l] : a || o[r ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: t,
      height: e,
      "aria-labelledby": s,
      ...h,
      children: [
        c ? /* @__PURE__ */ i("title", { id: s, children: c }) : null,
        /* @__PURE__ */ i("g", { clipPath: "url(#TikTok_svg__a)", children: /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M51.536 20.625a12.024 12.024 0 0 1-5.465-10.057h-8.626l-.014 34.567c-.146 3.872-3.33 6.979-7.236 6.979a7.203 7.203 0 0 1-3.363-.834c-2.307-1.215-3.888-3.634-3.888-6.417 0-3.998 3.253-7.25 7.25-7.25.748 0 1.462.122 2.141.335v-8.806c-.7-.095-1.413-.155-2.14-.155-8.754 0-15.876 7.123-15.876 15.876 0 5.371 2.684 10.125 6.777 12.998a15.78 15.78 0 0 0 9.099 2.877c8.753 0 15.876-7.121 15.876-15.877V27.334a20.512 20.512 0 0 0 12 3.86v-8.626c-2.408 0-4.653-.717-6.534-1.944l-.001.002Z"
          }
        ) }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "TikTok_svg__a", children: /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as TikTok
};
